module.exports = __webpack_public_path__ + "static/media/background.543a168a.png";